import { CircularProgress } from '@mui/material';
import { Onboarding } from './components/Onboarding';
import { useHomeViewModel } from './home.viewModel';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { CreatorLinks } from './components/CreatorLinks';
import { CreatorInformationSections } from './staticContent/CreatorInformationSections';
import { Header } from './components/Header';
import { CaseStudies } from './components/CaseStudies';
import { IOSAppQrCodeModal } from './components/IosAppQrCodeModal';
import { Feedback } from './components/Feedback';
import { OfferModal } from './components/offerModal/OfferModal';
import { GoLiveModal } from './components/GoLiveModal';
import { LiveSuccessModal } from './components/LiveSuccessModal';
import { EducationCloseConfirmationModal } from './components/EducationCloseConfirmationModal';

import handbook from './components/handbook.png';
import growthClub from './components/growth_club.png';
import { FeatureSection } from './components/FeatureSection';
import { OnboardingCard } from './components/OnboardingCard';
import { cardsSection, externalUrls } from './mappers';
import { WebinarModal } from './components/WebinarModal';
import { mixTrack } from '@services/mixpanel';
import { SuperTooltipModal } from './components/SuperTooltipModal';

export const HomePage = (p: { params: { influencerId?: string } }) => {
  const vm = useHomeViewModel({ influencerId: p.params.influencerId });

  return (
    <AsyncRenderer
      data={vm}
      loadRender={<CircularProgress />}
      renderer={(data) => (
        <div className="w-full flex flex-col gap-8 max-w-[1200px] mx-auto">
          <Header {...data.headline} />
          <Onboarding {...data.onboarding} />
          <CreatorLinks {...data} />

          <div className="flex flex-row gap-4">
            {cardsSection.map((card) => (
              <OnboardingCard
                key={card.title}
                title={card.title}
                description={card.description}
                image={card.image}
                link={card.link}
                onClick={() => {
                  mixTrack({
                    type: 'Onboarding Tile Tapped',
                    payload: {
                      Title: card.title,
                      Source: data.isLive ? 'Post-Launch' : 'Pre-Launch',
                    },
                  });
                }}
              />
            ))}
          </div>

          <FeatureSection
            title="Need more help?"
            description="Explore our video library in the Playbook Handbook to help answer your questions "
            onClick={() => {
              window.open(externalUrls['handbook'], '_blank');
              mixTrack({
                type: 'Onboarding Guide Tapped',
                payload: {
                  Source: data.isLive ? 'Post-Launch' : 'Pre-Launch',
                },
              });
            }}
            ctaText="Go to Handbook"
            imageSrc={handbook}
          />

          {!data.isLive ? (
            <FeatureSection
              title="Playbook's Growth Club"
              description="Become a wiz at selling online and participate in our exclusive channel meant to teach you everything you need to know to start making money fast."
              onClick={() => {
                mixTrack({
                  type: 'Onboarding Tile Tapped',
                  payload: {
                    Title: 'Join the Growth Club',
                    Source: data.isLive ? 'Post-Launch' : 'Pre-Launch',
                  },
                });
                window.open(externalUrls['webinar'], '_blank');
              }}
              ctaText="Join the Growth Club"
              imageSrc={growthClub}
              reverse
            />
          ) : null}
          <Feedback {...data.feedback} influencerId={data.influencerId} />
          <CreatorInformationSections isLive={data.isLive} />
          <IOSAppQrCodeModal
            isOpen={data.qrCodeModal.open}
            onClose={data.qrCodeModal.onClose}
          />
          <OfferModal {...data.offerModal} />
          <EducationCloseConfirmationModal
            {...data.educationCloseConfirmation}
          />
          <GoLiveModal {...data.goLiveModal} />
          <LiveSuccessModal {...data.liveSuccessModal} />
          <WebinarModal {...data.webinarModal} />
          <SuperTooltipModal {...data.superTooltip} />
          <CaseStudies />
        </div>
      )}
    />
  );
};
